export default __webpack_public_path__ + "static/media/AMZN_A3.8f7c6fbc.svg";